import SocialRow from "./SocialRow"

export default function Kaleb()
{
  return (
    <div className="front-page">
      <div className="front-page-content">
        <h2>Kaleb Bermond</h2>
        <h4>
          Game Developer and Software Developer, Park University Graduate from Kansas City, Missouri, United States
        </h4>
        <SocialRow/>
        <i className="chevron"></i>
        <img style={{margin: "2em"}} src="" alt="arrow pointing down"/>
      </div>
    </div>
  )
}